import { CERolePermissionBase } from './ce-role-permission-base'


export class CERolePermission extends CERolePermissionBase {

}